import loadable from '@loadable/component';

import LoadingPage from '../../components/LoadingPage';

const LoadableMyRecentActivitiesPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableMyRecentActivitiesPage;
